import { render, staticRenderFns } from "./kdAdditionalNotes.vue?vue&type=template&id=0c97b2bc"
import script from "./kdAdditionalNotes.vue?vue&type=script&lang=js"
export * from "./kdAdditionalNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports